<template>
  <div class="flex-col page">
    <div class="flex-row justify-center relative group">
      <img
        @click="$router.back()"
        class="image pos"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=73da474f9f0a9d2a13c183e0f2ed8f88.png"
      />
      <span class="self-start text">剪辑完成</span>
    </div>
    <div class="mt-38 flex-col group_2">
      <span class="self-start text_2">最新：2024年学平险保障范围全面扩大</span>
      <div class="flex-col justify-start items-center self-start text-wrapper">
        <span class="text_3">保险科普</span>
      </div>
      <div class="flex-col self-stretch group_3">
        <div class="flex-col items-center section"
             @click="playOrPause">
          <video src="/2.mp4" style="
              width: 100%;
              height: 100%;
          "></video>
          <img
            v-show="!playing"
            class="image_2"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=18340cface83549b504e558c91d52e60.png"
          />
        </div>
        <div class="mt-28 flex-col justify-start items-center text-wrapper_2" @click="downloadVideo">
          <span class="text_5">保存至本地</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {
        playing: false
      };
    },

    methods: {
      playOrPause() {
        const video = document.querySelector('video');
        if (video.paused) {
          video.play();
          this.playing = true;
        } else {
          video.pause();
          this.playing = false;
        }
      },
      downloadVideo() {
        const video = document.querySelector('video');
        const a = document.createElement('a');
        a.href = video.src;
        a.download = '2.mp4';
        a.click()
      }
    },
  };
</script>

<style scoped lang="less">
  .mt-168 {
    margin-top: 168px;
  }
  .page {
    padding: 14px 16px 45px;
    background-color: rgb(17, 17, 17);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      padding-bottom: 10px;
      .image {
        border-radius: 5px;
        width: 24px;
        height: 24px;
      }
      .pos {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .text {
        color: rgb(255, 255, 255);
        font-size: 18px;
        font-family: 思源黑体;
        font-weight: 700;
        line-height: 17px;
      }
    }
    .group_2 {
      padding: 0 24px;
      .text_2 {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
        font-family: 思源黑体;
        line-height: 15px;
      }
      .text-wrapper {
        margin-top: 16px;
        padding: 4px 0 8px;
        background-color: rgb(85, 239, 227);
        border-radius: 8px;
        width: 64px;
        .text_3 {
          color: rgb(17, 17, 17);
          font-size: 12px;
          font-family: Barlow;
          line-height: 11px;
        }
      }
      .group_3 {
        padding-top: 18px;
        .section {
          //background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=b302b3714138c630584654ac1e4a6923.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          position: relative;
          height: 450px;
          .image_2 {
            position: absolute;
            top: 50%;
            border-radius: 50%;
            width: 40px;
            height: 40px;
          }
          .text_4 {
            color: rgb(249, 249, 249);
            font-size: 20px;
            line-height: 14.5px;
            text-shadow: 0 1px #000000, 0 -1px #000000, 1px 0 #000000, -1px 0 rgb(0, 0, 0);
          }
        }
        .text-wrapper_2 {
          margin: 20px 5px 0;
          padding: 19px 0 22px;
          background-color: rgb(85, 239, 227);
          border-radius: 16px;
          overflow: hidden;
          .text_5 {
            color: rgb(17, 17, 17);
            font-size: 22px;
            font-weight: 600;
            line-height: 20.5px;
            letter-spacing: 2px;
          }
        }
      }
    }
  }
</style>
